import { FC } from 'react';
import { Alert, Link } from '@servicetitan/anvil2';
import { useHistory } from 'react-router-dom';

import { ErrorModel } from '../models/error.model';

interface ErrorViewProps {
    data: ErrorModel;
}

export const ErrorView: FC<ErrorViewProps> = ({ data }) => {
    const history = useHistory();

    const handleNavigate = () => {
        if (data.link) {
            history.push(data.link?.to);
        }
    };

    return (
        <Alert status="danger" title={data.title}>
            {data.message}
            {data.link && <Link onClick={handleNavigate}>{data.link.text}</Link>}
        </Alert>
    );
};
